<template>
  <div id="import">
    <div v-if="!value&&!exam" class="view-file" style="margin-bottom:20px">
      <span>具体课程:&nbsp;&nbsp;&nbsp;</span>
      <el-cascader
        clearable
        :show-all-levels="false"
        v-model="importForm.courseId"
        :props="subjectTreeProps"
        placeholder="请输入具体课程"
        :options="subjectTreeList"
        @change="subjectChange"
      ></el-cascader>
    </div>
    <!-- {{exam}}{{value}} -->
    <div class="view-file">
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :on-error="fileError"
        :file-list="fileList"
        :show-file-list="false"
      >
        <el-button
          size="small"
          type="primary"
          @click="loading=true"
          :loading="loading"
          icon="el-icon-upload"
        >点击上传</el-button>
      </el-upload>
      <el-button @click="downloadFile" style="margin-left:10px;" size="small" type="primary">模板下载</el-button>
      <div slot="tip" class="el-upload__tip" style="margin-left:10px;">只能上传xls、xlsx文件，且不超过1024kb</div>
    </div>

    <el-table
      ref="multipleTable"
      :data="importForm.rows"
      tooltip-effect="dark"
      style="margin-top: 20px; width: 100%;"
      height="520"
      border
      row-key="ids"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      @selection-change="selectionChange"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->

      <el-table-column prop="questionTypeName" width="200" label="试题题型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="title" label="标题题干" show-overflow-tooltip></el-table-column>
      <el-table-column prop="answer" label="试题答案" show-overflow-tooltip></el-table-column>
      <el-table-column prop="knowledgeName" label="考点" show-overflow-tooltip></el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer" style="text-align: left">
      <el-button
        type="primary"
        style="margin-top:20px"
        @click="importData"
        icon="el-icon-document"
      >导入数据</el-button>
      <el-button type="primary" style="margin-top:20px" @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    exam: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [], //课程，
      fileAction: `${process.env.BASE_URL}/question/importQuestions`,
      importForm: {
        rows: [],
        questionList: [],
        chapterId: "",
        examId: "",
        courseId: ""
      },
      fileList: [],
      reqData: {
        OpenId: JSON.parse(localStorage.getItem("user"))
          ? JSON.parse(localStorage.getItem("user")).id
          : "",
        Token: JSON.parse(localStorage.getItem("user"))
          ? JSON.parse(localStorage.getItem("user")).token
          : ""
      }
    };
  },
  created() {
    this.getSubjectTreeList();
  },
  methods: {
    fileError(response, file, fileList, $event) {
      this.$message.error("上传失败");
    },
    close() {
      this.$emit("showDiolog", false);
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  //   delete items.children;
                }
              }
            } else {
              //   delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange(val) {
      if (val) {
        if (val.length > 0) {
          this.importForm.courseId = val[val.length - 1];
        } else {
          this.importForm.courseId = "";
        }
      }
    },
    downloadFile() {
      // window.open(
      //   "http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15717971761918563706065.xls+"&tables="+试题批量录入模板"
      // );
      // const url =
      //   "http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15717971761918563706065.xls";
      const url = "./static/file/批量导入试题模板.xlsx";
      window.open(url);

      // const link = document.createElement("a");
      // link.style.display = "none";
      // link.href = url;
      // link.setAttribute("download", "试题批量录入模板");
      // document.body.appendChild(link);
      // link.click();
    },
    handleSuccess(response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      if (response.data.length == 0) {
        this.$message.success(response.message);
      }
      for (let inx in response.data) {
        response.data[inx].ids = inx;
        for (let index in response.data[inx].children) {
          response.data[inx].children[index].ids = inx * 10 + index;
        }
      }

      this.importForm.rows = response.data;
      this.importForm.questionList = response.data;
      this.loading = false;
    },
    selectionChange(val) {
      this.importForm.questionList = val;
      console.log(this.importForm.questionList);
    },
    importData() {
      // if (this.importForm.courseId.length < 2 && !this.value) {
      //   return this.$message({
      //     type: "error",
      //     message: "请选择具体课程哦！！！"
      //   });
      // }
      if (!this.value && !this.exam && this.importForm.courseId.length < 2) {
        return this.$message({
          type: "error",
          message: "请选择具体课程哦！！！"
        });
      }
      console.log("this.exam", this.exam);
      // if (this.importForm.courseId.length < 2 && !this.exam) {
      //   return this.$message({
      //     type: "error",
      //     message: "请选择具体课程哦！！！"
      //   });
      // }
      if (this.importForm.questionList.length == 0) {
        return this.$message({
          type: "error",
          message: "请导入试题哦！！！"
        });
      }
      delete this.importForm.rows;
      let apiStyle;
      if (this.value) {
        apiStyle = "addQuestionBatchChapter";
        this.importForm.chapterId = this.value;
      } else if (this.exam) {
        apiStyle = "addQuestionBatchExam";
        this.importForm.examId = this.exam;
      } else {
        apiStyle = "addQuestionBatch";
      }
      this.api[apiStyle](this.importForm)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.$emit("showDiolog", false);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {}
};
</script>

<style lang="less" rel="stylesheet/less">
#import {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/import.vue